/*
    Collect overflowing filter items into a “More” dropdown.
    Applies to every `.m-filter` instance on the page.
*/

(function () {
    const SAFETY = 32; // pixels reserved to avoid edge overflow
    const initialized = new WeakSet();

    function initCollectItemsMenu(root) {
        const list = root.querySelector('.js-filterItems');
        const more = root.querySelector('.js-filterMore');
        const moreBtn = root.querySelector('.js-filterMoreBtn');
        const moreMenu = root.querySelector('.js-filterMenu');

        if (!list || !more || !moreBtn || !moreMenu) return;

        // Keep references to items that can overflow (all items before the "More" li)
        const overflowable = Array.from(list.children).filter(function (li) { return li !== more; });

        function updateMoreVisibility() {
            const hasItems = moreMenu.children.length > 0;
            // Explicitly set display so we override stylesheet default display:none
            more.style.display = hasItems ? 'block' : 'none';
            if (!hasItems) {
                moreBtn.setAttribute('aria-expanded', 'false');
                moreMenu.setAttribute('aria-hidden', 'true');
            }
        }

        function moveToMore(li) {
            const entry = document.createElement('li');
            entry.className = 'm-filter__menuItem';
            const link = li.querySelector('a');
            if (!link) return;
            const clone = link.cloneNode(true);
            entry.appendChild(clone);
            moreMenu.insertBefore(entry, moreMenu.firstChild); // newest at top
            li.dataset._inMore = '1';
            li.style.display = 'none';
            updateMoreVisibility();
        }

        function moveBackFromMore(li) {
            // Show original li
            li.style.display = '';
            delete li.dataset._inMore;
            // Remove first matching clone (by href + text)
            const href = li.querySelector('a') ? (li.querySelector('a').getAttribute('href') || '') : '';
            const text = (li.textContent || '').trim();
            const items = Array.from(moreMenu.children);
            const idx = items.findIndex(function (mi) {
                const a = mi.querySelector('a');
                return a && (a.getAttribute('href') === href) && ((a.textContent || '').trim() === text);
            });
            if (idx >= 0) items[idx].remove();
            updateMoreVisibility();
        }

        function toggleMenu(open) {
            const isOpen = (open != null) ? open : (moreMenu.getAttribute('aria-hidden') === 'true');
            moreBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
            moreMenu.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
        }

        function relayout() {
            // Close dropdown while relayout to avoid odd positioning
            moreBtn.setAttribute('aria-expanded', 'false');
            moreMenu.setAttribute('aria-hidden', 'true');

            // Bring everything back first
            overflowable.forEach(function (li) {
                if (li.dataset._inMore) moveBackFromMore(li);
            });

            // Compute available width based on the container's content box
            const container = list.parentElement;
            const containerStyle = container ? getComputedStyle(container) : null;
            const containerPaddingX = containerStyle ? ((parseFloat(containerStyle.paddingLeft) || 0) + (parseFloat(containerStyle.paddingRight) || 0)) : 0;
            const containerContentWidth = (container ? container.clientWidth : list.clientWidth) - containerPaddingX;

            // List own spacing that reduces space for items
            const listStyle = getComputedStyle(list);
            const listPaddingX = (parseFloat(listStyle.paddingLeft) || 0) + (parseFloat(listStyle.paddingRight) || 0);
            const listMarginX = (parseFloat(listStyle.marginLeft) || 0) + (parseFloat(listStyle.marginRight) || 0);

            const availableWidth = Math.max(0, containerContentWidth - SAFETY);

            const children = Array.from(list.children);
            const style = getComputedStyle(list);
            const gap = parseFloat(style.columnGap || style.gap || 0);
            const visibleItems = children.filter(function (li) { return li !== more && li.style.display !== 'none'; });

            // Measure sum of visible items (including flex gaps between them)
            var used = 0;
            for (var i = 0; i < visibleItems.length; i++) {
                used += visibleItems[i].offsetWidth + (i ? gap : 0);
            }

            // Include list padding and horizontal margins as they consume horizontal space
            used += listPaddingX + listMarginX;

            const connectorGap = visibleItems.length ? gap : 0;
            // First check without reserving More width
            const baseWithoutMore = used + connectorGap;
            if (baseWithoutMore <= availableWidth) {
                updateMoreVisibility();
                return;
            }

            // Otherwise, measure and include the More button footprint
            more.style.display = 'block';
            const moreWidth = more.offsetWidth;
            const baseWithMore = used + connectorGap + moreWidth;

            function lastVisible() {
                for (var j = overflowable.length - 1; j >= 0; j--) {
                    var li = overflowable[j];
                    if (li.style.display !== 'none') return li;
                }
                return null;
            }

            var currentUsed = baseWithMore;
            while (currentUsed > availableWidth) {
                var li2 = lastVisible();
                if (!li2) break;
                currentUsed -= (li2.offsetWidth + gap);
                moveToMore(li2);
            }

            // Try to move items back if there is extra room (from More → bar)
            for (var k = 0; k < overflowable.length; k++) {
                var li3 = overflowable[k];
                if (!li3.dataset._inMore) continue;

                // Tentatively show it and measure exact width
                li3.style.display = '';
                const wouldVisible = overflowable.filter(function (x) { return x.style.display !== 'none'; });
                var itemsWidth = 0;
                for (var m = 0; m < wouldVisible.length; m++) {
                    itemsWidth += wouldVisible[m].offsetWidth + (m ? gap : 0);
                }
                const connectorGap2 = wouldVisible.length ? gap : 0;
                // If this is the last item in the menu, do not reserve More width
                const isLast = (moreMenu.children.length <= 1);
                const wouldTotal = isLast
                    ? (itemsWidth + listPaddingX + listMarginX)
                    : (itemsWidth + connectorGap2 + more.offsetWidth + listPaddingX + listMarginX);
                const fits = (availableWidth >= wouldTotal);

                // Re-hide before acting
                li3.style.display = 'none';
                if (!fits) break;
                moveBackFromMore(li3);
            }

            updateMoreVisibility();
        }

        // Events
        moreBtn.addEventListener('click', function () { toggleMenu(); });
        document.addEventListener('click', function (e) {
            if (!more.contains(e.target)) {
                moreBtn.setAttribute('aria-expanded', 'false');
                moreMenu.setAttribute('aria-hidden', 'true');
            }
        });
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') {
                moreBtn.setAttribute('aria-expanded', 'false');
                moreMenu.setAttribute('aria-hidden', 'true');
                moreBtn.focus();
            }
        });

        // Resize/Load with RAF debounce
        var raf;
        function schedule() {
            cancelAnimationFrame(raf);
            raf = requestAnimationFrame(relayout);
        }
        function scheduleBurst() {
            // One now, one next frame, one slightly later to cover late shifts
            schedule();
            requestAnimationFrame(function () { schedule(); });
            setTimeout(function () { schedule(); }, 120);
        }
        window.addEventListener('resize', schedule);
        window.addEventListener('load', schedule);
        window.addEventListener('pageshow', schedule);
        window.addEventListener('orientationchange', schedule);
        window.addEventListener('focus', schedule);
        document.addEventListener('visibilitychange', function () {
            if (document.visibilityState === 'visible') schedule();
        });

        // Recalculate once web fonts are ready, as they can change item widths
        if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(function () { scheduleBurst(); });
        }

        // Observe size changes of the container and list to catch late layout/visibility changes
        if (typeof ResizeObserver !== 'undefined') {
            var ro = new ResizeObserver(function () { schedule(); });
            var parent = list.parentElement;
            if (parent) ro.observe(parent);
            ro.observe(list);
        }

        // Initial layout (burst to ensure styles/layout/fonts are settled)
        scheduleBurst();
    }

    function initAll() {
        var components = document.querySelectorAll('.js-filter');
        for (var i = 0; i < components.length; i++) {
            var el = components[i];
            if (!initialized.has(el)) {
                initialized.add(el);
                initCollectItemsMenu(el);
            }
        }
    }

    // Auto-init for dynamically inserted filters
    if (typeof MutationObserver !== 'undefined') {
        var mo = new MutationObserver(function (mutations) {
            for (var i = 0; i < mutations.length; i++) {
                var m = mutations[i];
                for (var j = 0; j < m.addedNodes.length; j++) {
                    var node = m.addedNodes[j];
                    if (!(node instanceof Element)) continue;
                    if (node.matches && node.matches('.js-filter')) {
                        if (!initialized.has(node)) {
                            initialized.add(node);
                            initCollectItemsMenu(node);
                        }
                    }
                    var inner = node.querySelectorAll ? node.querySelectorAll('.js-filter') : [];
                    for (var k = 0; k < inner.length; k++) {
                        var el = inner[k];
                        if (!initialized.has(el)) {
                            initialized.add(el);
                            initCollectItemsMenu(el);
                        }
                    }
                }
            }
        });
        mo.observe(document.documentElement, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAll);
    } else {
        initAll();
    }
})();